var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11C12.9574 11 13.8101 10.5515 14.3594 9.85315C16.1722 11.04 17.4828 12.8797 18.0028 15H18C16.8954 15 16 15.8954 16 17V19C16 20.1046 16.8954 21 18 21H20C21.1046 21 22 20.1046 22 19V17C22 15.8954 21.1046 15 20 15H19.5405C19.0127 12.4496 17.5178 10.2152 15.4064 8.75H18.1454C18.4421 9.48296 19.1607 10 20 10C21.1046 10 22 9.10457 22 8C22 6.89543 21.1046 6 20 6C19.1607 6 18.4421 6.51704 18.1454 7.25H14.9055C14.5725 5.95608 13.3979 5 12 5C10.6021 5 9.42755 5.95608 9.09451 7.25H5.85462C5.55793 6.51704 4.83934 6 4 6C2.89543 6 2 6.89543 2 8C2 9.10457 2.89543 10 4 10C4.83934 10 5.55793 9.48296 5.85462 8.75H8.59356C6.48221 10.2152 4.98733 12.4496 4.45946 15H4C2.89543 15 2 15.8954 2 17V19C2 20.1046 2.89543 21 4 21H6C7.10457 21 8 20.1046 8 19V17C8 15.8954 7.10457 15 6 15H5.99719C6.51725 12.8797 7.82776 11.04 9.64063 9.85315C10.1899 10.5515 11.0426 11 12 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.755bd60a9c6e4f72c4dda08a19251085.svg";
export { ForwardRef as ReactComponent };